<template>
  <FieldValidator :name="name">
    <template v-slot="{ value, handleChange, isInvalid, errorMessage, setTouched }">
      <!-- @vue-expect-error FIXME: value not assignable to type 'string' -->
      <Textarea
        :modelValue="value"
        @update:modelValue="handleChange"
        :class="{ 'p-invalid': isInvalid }"
        v-bind="$attrs"
        ref="textarea"
        @change="setTouched(true)"
      >
        <template v-if="label" #label>{{ label }}</template>

        <template v-if="$slots.helperText" #helperText>
          <slot name="helperText" />
        </template>

        <template v-if="$slots.customCounter" #customCounter>
          <slot name="customCounter" />
        </template>

        <template v-if="isInvalid" #helperText>{{ errorMessage }}</template>
      </Textarea>
    </template>
  </FieldValidator>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { Textarea } from './../../../core/controls/textarea';
import { FieldValidator } from './../field-validator';

defineProps({
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
  },
});

const textarea = ref<InstanceType<typeof Textarea>>();

defineExpose({ textarea });
</script>
